import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation, FreeMode, Thumbs, Autoplay } from 'swiper/modules';

export default class Banner {

    constructor() {
        this.sections = document.querySelectorAll('.block-banner');

        this.instances = []; // guarda sliders criados
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    /* -------------------------------------------------------
     * Debounce para evitar disparos excessivos no resize
     * ------------------------------------------------------- */
    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    /* -------------------------------------------------------
     * Destrói tudo e recria conforme o tamanho da tela
     * ------------------------------------------------------- */
    rebuild() {
        // 1. destruir instâncias atuais
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
            obj.thumbs?.destroy(true, true);
        });
        this.instances = [];

        // 2. remover thumbs criados dinamicamente
        this.sections.forEach(section => {
            const wrapper = section.querySelector('.swiper-thumbs .swiper-wrapper');
            if (wrapper) wrapper.innerHTML = '';
        });

        // 3. recriar tudo
        this.ready();
    }

    /* -------------------------------------------------------
     * Inicialização completa
     * ------------------------------------------------------- */
    ready() {
        if (this.sections.length === 0) return;

        this.sections.forEach(section => {

            const slider = section.querySelector('.main-swiper');
            const navigationNext = section.querySelector('.slider-button-next');
            const navigationPrev = section.querySelector('.slider-button-prev');
            const pagination = section.querySelector('.swiper-pagination');
            const sliderThumbsWrapper = section.querySelector('.swiper-thumbs .swiper-wrapper');

            /* ------------------------------------------
             * 1. Criar thumbs dinamicamente no desktop
             * ------------------------------------------ */
            if (slider && sliderThumbsWrapper && window.innerWidth >= 1380) {
                const slides = slider.querySelectorAll('.swiper-slide');
                slides.forEach((slide, i) => {
                    const idx = String(i + 1).padStart(2, '0');
                    const title = slide.dataset.title || '';

                    const thumb = document.createElement('div');
                    thumb.className = 'swiper-slide group hover:cursor-pointer !h-auto';
                    thumb.innerHTML = `
                        <div class="flex flex-col relative pl-[0.875rem] py-1 justify-center">
                            <div class="absolute left-0 z-5 flex w-px h-full bg-white group-[.swiper-slide-thumb-active]:bg-primary group-[.swiper-slide-thumb-active]:w-1"></div>
                            <div class="relative z-5 flex font-bold text-white text-sm leading-[0.875rem]">${idx}</div>
                            <div class="relative z-5 text-sm font-bold leading-[0.875rem] tracking-widest text-white line-clamp-2">${title}</div>
                            <div class="absolute left-0 top-0 bottom-0 z-1 h-full bg-white/20 w-0 group-hover:w-full transition-[width] duration-500 ease-in-out overflow-hidden"></div>
                        </div>
                    `;
                    sliderThumbsWrapper.appendChild(thumb);
                });
            }

            /* ------------------------------------------
             * 2. Thumbs Swiper (somente desktop)
             * ------------------------------------------ */
            let swiperThumbs = null;

            if (window.innerWidth >= 1380) {
                const thumbsContainer = section.querySelector('.swiper-thumbs');
                if (thumbsContainer) {
                    swiperThumbs = new Swiper(thumbsContainer, {
                        modules: [FreeMode],
                        spaceBetween: 2,
                        slidesPerView: 3,
                        freeMode: true,
                        grabCursor: false,
                        watchSlidesProgress: true,
                    });
                }
            }

            /* ------------------------------------------
             * 3. Swiper principal
             * ------------------------------------------ */
            const swiperInstance = new Swiper(slider, {
                modules: [Pagination, Navigation, Thumbs, Autoplay],

                grabCursor: false,
                allowTouchMove: true,
                centeredSlides: true,
                spaceBetween: 0,

                breakpoints: {
                    0: {
                        pagination: {
                            el: pagination,
                            clickable: true,
                            type: 'bullets'
                        },
                        navigation: false
                    },
                    1024: {
                        pagination: false,
                        navigation: {
                            nextEl: navigationNext,
                            prevEl: navigationPrev,
                        },
                    }
                },

                thumbs: swiperThumbs ? { swiper: swiperThumbs } : {},

                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                }
            });

            swiperInstance.autoplay.stop();

            const startAutoplay = () => {
                section.classList.add('banner-loaded');
                swiperInstance.update();
                swiperInstance.autoplay.start();
            };

            if (document.readyState === 'complete') {
                startAutoplay();
            } else {
                window.addEventListener('load', startAutoplay, { once: true });
            }

            /* ------------------------------------------
             * Guardar instâncias
             * ------------------------------------------ */
            this.instances.push({
                main: swiperInstance,
                thumbs: swiperThumbs
            });
        });
    }
}

if (document.querySelector('.block-banner')) {
    globalThis.banner = new Banner();
}
